<template>
    <div>
        <!-- Modal -->
        <div class="modal fade" id="kpiFormulaModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">KPI</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" v-if="item">
                        <div class="form-row">
                            <div class="col-12">
                                <az-input 
                                    v-model="item.id" 
                                    label="KPI"
                                    type="select"
                                    :optionsList="dados.qockpit_kpis"
                                    optionsData="id"
                                    optionsDisplay="name">
                                    <template v-slot:buttonposb>
                                        <div class="input-group-append" v-if="item.id">
                                            <div class="input-group-text">
                                                #{{ item.id }}
                                            </div>
                                        </div>
                                    </template>
                                </az-input>
                            </div>
                        </div>

                        <div class="form-row">
                            <div class="col-12">
                                <az-input 
                                    v-model="item.formula" 
                                    label="Fórmula"
                                    type="textarea"
                                    placeholder="Informar..."
                                    rows="3" />
                            </div>
                        </div>

                        <table class="table table-hover table-sm">
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Título</th>
                                    <th>Tipo</th>
                                    <th>Status</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(dsi, idx) in dados.dashboard_items" :key="idx">
                                    <td>{{ idx + 1 }}</td>
                                    <td>
                                        <a href="#" @click.prevent="colar_na_formula(idx + 1)" class="card-link">
                                            {{ dsi.title }}
                                        </a>
                                    </td>
                                    <td>{{ dsi.dashboard_item_type.description }}</td>
                                    <td>{{ dsi.active ? 'Ativo' : 'Inativo' }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                        <button type="button" class="btn btn-primary">Save</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import AzInput from '../shared/forms/AzInput.vue';

export default {
    data() {
        return { 
            item: null, 
        }
    },

    components: { 
        AzInput, 
    },

    props: ['dados'], 

    computed: { 
        lista_campos: function () { 
            if ( !this.dados || !this.dados.dados.dashboard_items || !this.dados.dados.dashboard_items.length ) { 
                return []; 
            }

            let lista = []; 

            this.dados.dados.dashboard_items.forEach( item => { 
                if ( item.tipo !== 'kpi' ) { 
                    return; 
                }

                if ( item.config && item.config.campo ) { 
                    lista.push( item.config.campo ); 
                }
            });

            return this.dados ? this.dados.dashboard_kpi_formulas : []; 
        },
    },

    methods: { 
        colar_na_formula (idx) { 
            if ( !this.item || !this.item.formula ) { 
                this.item.formula = ''; 
            }

            this.item.formula += ` #${idx} `; 
        },
        incluir () { 
            this.item = { 
                id: null, 
                formula: '',
            };

            $('#kpiFormulaModal').modal('show');
        },

        editar (item) { 
            this.item = _.cloneDeep(item); 

            $('#kpiFormulaModal').modal('show');
        },
    }
}
</script>
